import Core from '@aws-amplify/core';
/* eslint-disable no-console */
export const logger = store => next => action => {
  const logger = new Core.Logger(
    'Store',
    process.env.REACT_APP_ENV === 'production' ? 'ERROR' : 'DEBUG'
  );
  logger.debug(`Process started in ${process.env.REACT_APP_ENV} mode`);
  if (typeof action !== 'function') {
    logger.debug('dispatching', action);
  }
  let result = next(action);
  logger.debug('next state', store.getState());
  return result;
};
